<template>

        <md-card>
          <!-- <md-card-header class="md-card-header-icon">
            <div class="card-icon">
              <md-icon>design_services</md-icon>
            </div>
            <h4 class="title">
              Service Information
            </h4>
          </md-card-header> -->
          <md-card-content>

            <div class="md-layout">
                <div class="md-layout-item">
              <autoextra :collection="identity" v-slot="{item,last,index}">
              <div  :class="{last: last}">
                <div v-if="item.driver_identity_type || item.driver_identity_type == 0 || last" class="columns">
                <label :id="'labelIdentityFlag__'+index" style="font-weight:bold;" class="label">{{last ? 'New ' : ''}}Identity {{!last ? index + 1 : ''}}</label>
                <div class="md-layout md-gutter">

                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px;">

                  <input v-model="item.id" :readonly="true" type="hidden"/>

                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Identity Type</label>
                      <md-select  v-model="item.driver_identity_type" @md-selected="onChangeIndetityType()" required>
                        <md-option value="0">KTP</md-option>
                        <md-option value="1">SKCK</md-option>
                        <md-option value="2">Domisili</md-option>
                        <md-option value="3">KK</md-option>
                      </md-select>
                    </md-field>
                      <span :id="'flagIdentityType'" style="display:none; color:red;">Field is required</span>
                  </div>

                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Identity No</label>
                      <md-input  v-model="item.driver_identity_no" :disabled="!item.driver_identity_type && item.driver_identity_type != 0" @change="onChangeIdentytyNo(index, item.driver_identity_no)"/>
                    </md-field>
                    <span :id="'flagIdentity_'+index" style="display:none; color:red;">Field is required</span>
                  </div>

                  <div class="md-layout-item md-small-size-100">
                    <label class="md-layout-item md-size-15 md-form-label">Expire Date</label>
                    <md-field >
                      <md-input type="date" v-model="item.driver_identity_expire_date" :disabled="!item.driver_identity_type && item.driver_identity_type != 0"/>
                  
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-100" style="margin-top:25px;">
                    <md-field >
                      <label class="label" >Place Of Issue</label>
                      <md-input  v-model="item.driver_identity_place_of_issue" :disabled="!item.driver_identity_type && item.driver_identity_type != 0"/>
                  
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-100" style="margin-bottom:10px;">
                    <md-field >
                      <label class="label" >Address</label>
                      <md-textarea  v-model="item.driver_identity_address" maxlength="100" md-autogrow :disabled="!item.driver_identity_type && item.driver_identity_type != 0"></md-textarea>
                      <md-avatar >
                        <md-icon style="color:blue;">report</md-icon>
                        <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
                      </md-avatar>
                    </md-field>
                  </div>
                  
                    <div class="md-layout-item md-small-size-100">
                       <validation-provider  v-slot="{ errors }">
                      <md-field class="md-invalid">
                          <label >Photo Identity</label>
                          <md-file
                          ref="check_in"
                          @change="on_change_photo_identity(item.driver_attach_identity_view,index)"
                          v-model="item.driver_attach_identity_view"
                          accept="image/jpeg,image/png,application/pdf"
                          :disabled="!item.driver_identity_type && item.driver_identity_type != 0"
                          
                          />
                      <span class="md-error">{{ errors[0] }}</span>
                      </md-field>
                     <p v-if="item.driver_identity_attach && item.driver_identity_attach.type != 'image/jpeg' && item.driver_identity_attach.type != 'image/png'" class="mb-0" style="text-align:center;">size: {{ (item.driver_identity_attach.size / 1048576).toFixed(2) }}MB</p>
                      </validation-provider>
                    </div>
                  </div>

                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px;">

                        <template v-if="item.driver_identity_attach && (item.driver_identity_attach.type == 'image/jpeg' || item.driver_identity_attach.type == 'image/png')">
                        <!-- <img
                            :src="item.driver_identity_attach.base64"
                            class="img-fluid photo_list"
                            
                        /> -->
                        <viewer class="pointer" :src="item.driver_identity_attach.base64">
                          <img style="width: auto; max-height:400px; display: block; margin:auto;" :src="item.driver_identity_attach.base64" :alt="'driver identity photo '+index" >
                        </viewer>

                        <p class="mb-0" style="text-align:center;">
                            size: {{ (item.driver_identity_attach.size / 1048576).toFixed(2) }}MB 
                        </p>
                        </template>
                        <template v-if="!item.driver_identity_attach && item.url_driver_identity_file">
                          <template v-if="get_url_extension_image(item.url_driver_identity_file)">
                            <span style="color:green"
                              >Current Photo:
                            </span>
                            <!-- <img 
                                :src="driver.driver_photo"
                                style="height:auto; max-width:400px;"
                                class="img-fluid"
                              /> -->
                            <viewer class="pointer" :src="item.url_driver_identity_file">
                              <img style="width: auto; max-height:400px; display: block; margin:auto;" :src="item.url_driver_identity_file" :alt="'driver identity current photo '+index" >
                            </viewer>
                          </template>
                          <template v-else>
                          <span style="color:green"
                            >Current File:
                          </span>
                          <a target="_blank" :href="item.url_driver_identity_file">{{item.url_driver_identity_file.split('/').pop()}}</a>
                        </template>
                        </template>
                    </div>
                 
                  <md-card-actions style="border:none;">
                  <md-button class="md-danger md-dense"  @click="deleteColumn(index)" v-if="item.driver_identity_type || item.driver_identity_type == 0">
                    delete
                  </md-button>
                </md-card-actions>
                </div>            
              </div>
              </div>
            </autoextra>
            </div>
            </div>
          </md-card-content>
        </md-card>  
</template>
<script>
// import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
  // import {extend} from 'vee-validate';
  // import { required } from 'vee-validate/dist/rules';
import  Autoextra  from 'vue-autoextra';
import Swal from "sweetalert2";


export default {
  name: "identity-card",
props: ['driver'],

  components: {  Autoextra },

  mixins: [formMixin],
 
  data() {
    return {
     identity:[],
    //  identity_not_null:[],
    };
  },
  
  created() {
          this.onOpen()
  },
  // watch: {
  //   identity: {
  //     // the callback will be called immediately after the start of the observation
  //     immediate: true, 
  //     handler (val, oldVal) {
  //        var filtered = val.filter(function (el) {
  //             return el != null;
  //           });
  //           console.log(filtered)
  //            this.identity_not_null = filtered;
  //            console.log(this.identity_not_null)
  //     }
  //   }
  // },
  methods:{
    //fungsi saat pertamakali page di buka
    async onOpen(){
     
    },
      //ambil data dari parent, digunakan saat edit
      async getDataParent() { 
        // console.log(this.driver.driver_identity);
        // this.identity = this.driver.driver_identity
        //loop nilai identity untuk membuat autoextra row
        this.driver.driver_identity.forEach((value, index) => {
          this.$set(this.identity, index, {
                  id : value.id,
                  driver_identity_type : value.driver_identity_type,
                  driver_identity_no : value.driver_identity_no,
                  driver_identity_expire_date : value.driver_identity_expire_date,
                  driver_identity_place_of_issue : value.driver_identity_place_of_issue,
                  driver_identity_address : value.driver_identity_address,
                  driver_attach_identity_view : null,
                  driver_identity_attach : null,
                  url_driver_identity_file : value.url_driver_identity_file,
                });
          });
        console.log(this.identity);
      },

    
    onChangeIdentytyNo(index,data){
        let error = document.getElementById("flagIdentity_"+index);
        if(data!=null && data!=""){
        error.style.display = "none"
        }
        else{
          error.style.display = "block"
        }

      },

      get_url_extension_image(url) {
        const image_format = ["jpg", "jpeg", "pjpeg", "pjp", "png", "svg", "webp"];
        return image_format.includes(url.split(/[#?]/)[0].split('.').pop().trim());
    },


    onChangeIndetityType(){
       let error = document.getElementById("flagIdentityType");
        error.style.display = "none"
      flagIdentityType
      var filter = this.identity.filter(function(el) {
           console.log(el);
            return el != null;
          });
          console.log(filter)
          var int= 0
          for (const [key, value] of Object.entries(filter)) {
                        console.log(key);
                        console.log(value);
                        if(!value.driver_identity_type  && value.driver_identity_type != 0){
                          int++
                        }
                        else{
                          console.log(key-int);
                          this.$set(this.identity, key-int, { 
                             id : value.id,
                            driver_identity_type : value.driver_identity_type,
                            driver_identity_no : value.driver_identity_no,
                            driver_identity_expire_date : value.driver_identity_expire_date,
                            driver_identity_place_of_issue : value.driver_identity_place_of_issue,
                            driver_identity_address : value.driver_identity_address,
                            driver_identity_attach : value.driver_identity_attach,
                            driver_attach_identity_view : value.driver_attach_identity_view,
                            url_driver_identity_file : value.url_driver_identity_file,
                            
                          });
                          if(int!=0){
                            this.$set(this.identity, key, {
                               id :null,
                              driver_identity_type : null,
                              driver_identity_no : null,
                              driver_identity_expire_date : null,
                              driver_identity_place_of_issue : null,
                              driver_identity_address : null,
                              driver_identity_attach : null,
                              driver_attach_identity_view : null,
                              url_driver_identity_file : null,
                              
                            });
                          }
                          
                          int= 0
                        }
                        

                      }
      
    },

      on_change_photo_identity(event,index) {
        console.log(index)
      var input = event.target;
      console.log(this.driver_identity_attach)
      if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
          if(input.files[0]){
          this.sizeTobig(input.files[0].size) 
          }
          // this.resetFile('photo_driver')
          // this.driver_identity_attach = null
          // this.driver_identity_attach = null

          this.$set(this.identity, index, {
                  id : this.identity[index].id,
                  driver_identity_type : this.identity[index].driver_identity_type,
                  driver_identity_no : this.identity[index].driver_identity_no,
                  driver_identity_expire_date : this.identity[index].driver_identity_expire_date,
                  driver_identity_place_of_issue : this.identity[index].driver_identity_place_of_issue,
                  driver_identity_address : this.identity[index].driver_identity_address,
                  driver_identity_attach : null,
                  driver_attach_identity_view : null,
                  url_driver_identity_file : this.identity[index].url_driver_identity_file
                  
                });

          
          //console.log(this.driver_identity_attach)
          return
        }
      //check apakah data ada
      if (input.files) {
        var reader = new FileReader();
        //read file
        reader.onload = (e) => {
          //set array filedata
          const fileData = {
            name: input.files[0].name,
            size: input.files[0].size,
            lastModified: input.files[0].lastModified,
            lastModifiedDate: input.files[0].lastModifiedDate,
            type: input.files[0].type,
            base64: e.target.result,
          };
          //set var berdasarkan fildedata
          //this.driver_identity_attach = fileData;

           this.$set(this.identity, index, {
                  id : this.identity[index].id,
                  driver_identity_type : this.identity[index].driver_identity_type,
                  driver_identity_no : this.identity[index].driver_identity_no,
                  driver_identity_expire_date : this.identity[index].driver_identity_expire_date,
                  driver_identity_place_of_issue : this.identity[index].driver_identity_place_of_issue,
                  driver_identity_address : this.identity[index].driver_identity_address,
                  driver_attach_identity_view : fileData.name,
                  driver_identity_attach : fileData,
                  url_driver_identity_file : this.identity[index].url_driver_identity_file
                  
                });

        };
        reader.readAsDataURL(input.files[0]);
      }
    },

    sizeTobig(size){
      Swal.fire({
          icon: 'error',
          title: 'File is to big ('+(size / 1048576).toFixed(2)+'MB)',
          text: 'Maximum attachment file size 3MB',
        })
    },

    
    // focusNoEstimate(){
    //     // this.$refs.driver_no_input.$el.focus();
    //     this.$refs.driver_create_at_datetime_input.$el.focus();
      
    // },
    //fungsi untuk menghapus colum identity
    deleteColumn(index){
        if (index > -1) {
           this.identity.splice(index, 1)
        }
        
      },


      getData() {
        var filter = this.identity.filter(function(el) {
           console.log(el);
            return el != null;
          });
            this.$emit('data', filter)
        },

        async validateForm() {
          let result = []
      if(Object.keys(this.identity).length != 0){
        for (const [key, value] of Object.entries(this.identity)) {
          console.log(value.driver_identity_no+' - '+value.driver_identity_expire_date)
          if((value.driver_identity_type || value.driver_identity_type == 0) && !value.driver_identity_no){
            if(!value.driver_identity_no){
              document.getElementById("flagIdentity_"+key).style.display = "block"
            }
            document.getElementById("labelIdentityFlag_"+key).scrollIntoView({behavior: 'auto'});
            result.push(false)
          }
        }
      }

      if(this.identity.length == 0){
            document.getElementById("flagIdentityType").style.display = "block"
            document.getElementById("labelIdentityFlag_0").scrollIntoView({behavior: 'auto'});
            result.push(false)
      }
            return result.every(Boolean)
        }
  },
};
</script>

<style scoped>
.photo_list{
    max-width: 50%;
    height: auto;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.columns{
  margin-bottom: 3ex;
  border-bottom: 5px solid black;
}</style>
